import React from 'react';

import { Grid, Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import { FIRST_NAME, LAST_NAME, IM_ADDRESS, PHONE, EMAIL } from '../constants';

const LegalContact = ({ name, active }) => {
  return (
    <Section title={'Legal Contact Person'}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <FormField.TextField
            name={`${name}.${FIRST_NAME}`}
            label={'First Name'}
            active={active}
            required={true}
            padding={0}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.TextField
            name={`${name}.${LAST_NAME}`}
            label={'Last Name'}
            active={active}
            required={true}
            padding={0}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.TextField
            name={`${name}.${EMAIL}`}
            label={'Email'}
            active={active}
            required={true}
            padding={0}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.TextField
            name={`${name}.${IM_ADDRESS}`}
            label={'Skype'}
            active={active}
            padding={0}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.TextField
            name={`${name}.${PHONE}`}
            label={'Phone'}
            active={active}
            padding={0}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default LegalContact;
